import { css } from '@emotion/css';
import { colors } from '@ajaibid/components';

const { AJAIB_BLUE_1, NEUTRAL_0, AJAIB_BLUE_5, SLATE_GRAY_7 } = colors;

export const styNavbarMenu = css`
  width: 49.7px;
  background: ${NEUTRAL_0};
  border-radius: 4px 0px 0px 0px;
  margin: 4px 0 0 2px;
`;

export const styNavbarlist = css`
  list-style-type: none;
  padding: 0;
`;

export const styNavbarContent = (props) => css`
  display: inline-flex;
  position: relative;
  background: ${props.isActive ? AJAIB_BLUE_1 : 'transparent'};
  border-radius: 12px;
  padding: 8px;
  cursor: pointer;
`;

export const styNavbarProfile = css`
  position: absolute;
  bottom: 0;
  border-radius: 12px;
  padding: 10px;
  cursor: pointer;
`;

export const styNavbarBox = css`
  margin-top: 8px;
  text-align: center;

  &:first-child {
    margin-top: 16px;
  }
`;

export const styIconProfile = (props) => css`
  object-fit: contain;
  border-radius: 50%;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border: ${props.profileActive && `2px solid ${props.isPremium ? SLATE_GRAY_7 : AJAIB_BLUE_5}`};
`;

export const styProfileMenu = css`
  position: absolute;
  top: 0;
  right: 55px;
  width: 350px;
  background-color: ${NEUTRAL_0};
  height: 100%;
  overflow-y: auto;
  z-index: 100;

  border-radius: 12px;
  height: calc(100vh - 60px);
  box-shadow: 0px 16px 36px -8px #607a8d26;
`;
